import { getRoundedNumber } from '../../../../../shared/utils/mathUtils';
import { Measurement } from '../../../../interfaces/Measurement';
import { SaveFoodRequest } from '../../../../interfaces/SaveFoodRequest';
import {
  FOOD_FORM_NUTRIENTS,
  NUTRIENT_ROUNDING_PRECISION,
} from '../../constants/foodFormNutrients';
import { FoodFormValues } from '../../interfaces/FoodFormValues';

type Options = {
  /** the database template's selected measurement */
  measurement?: Measurement | null;
};

// the backend re-checks only the macros, and only for admin roles: micros and supplements rely on this rule
const getNutritionIxFoodId = (
  values: FoodFormValues,
  measurement?: Measurement | null,
) => {
  const { my_net_diary_bean_id, microNutrients, recommendedServingSize, nutrients } =
    values;

  if (!my_net_diary_bean_id || !measurement || microNutrients.length) {
    return null;
  }

  const isNutrientChanged = FOOD_FORM_NUTRIENTS.some(
    (key) =>
      nutrients[key] !==
      getRoundedNumber(
        measurement[key] * (recommendedServingSize || 0),
        NUTRIENT_ROUNDING_PRECISION,
      ),
  );

  return isNutrientChanged ? null : my_net_diary_bean_id;
};

export const formValuesToSaveRequest = (
  values: FoodFormValues,
  { measurement }: Options = {},
): SaveFoodRequest => {
  const { servingSize, servingPerContainer, nutrients } = values;

  return {
    id: values.id ?? 0,
    name: values.name,
    brand: values.brand ? values.brand.value : null,
    amountUnit: values.amountUnit,
    proteins: nutrients.proteins || 0,
    carbs: nutrients.carbs || 0,
    fats: nutrients.fats || 0,
    sugar: nutrients.sugar || 0,
    fiber: nutrients.fiber || 0,
    veggies: nutrients.veggies || 0,
    sodium: nutrients.sodium || 0,
    recommendedServingSize: values.recommendedServingSize || 0,
    barcode: values.barcode,
    activeCalendar: values.activeCalendar,
    servingSize: servingSize || null,
    servingPerContainer: servingPerContainer || null,
    totalPerContainer: values.totalPerContainer,
    my_net_diary_bean_id: getNutritionIxFoodId(values, measurement),
  };
};
